var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaroff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 6,
    viewBox: "0 0 8 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.16079 1.97853L5.21884 2.10781L5.36029 2.1164L7.05085 2.21912L7.05093 2.21912C7.19233 2.22767 7.27202 2.30634 7.29945 2.38187C7.32541 2.45337 7.313 2.53975 7.21979 2.60943L5.91986 3.58062L5.79099 3.6769L5.83457 3.83175L6.24787 5.30044C6.24787 5.30045 6.24788 5.30046 6.24788 5.30048C6.27134 5.38395 6.23919 5.46659 6.14924 5.52499C6.05758 5.5845 5.92936 5.59858 5.81539 5.53479C5.81535 5.53477 5.81531 5.53475 5.81527 5.53473L4.38043 4.72918L4.26578 4.66481L4.15111 4.72916L2.71608 5.53443L2.83072 5.73873L2.71608 5.53443C2.60214 5.59837 2.47394 5.58432 2.38227 5.5248C2.29224 5.46635 2.26019 5.3837 2.28362 5.3005L2.28362 5.30048L2.69694 3.83175L2.74051 3.6769L2.61164 3.58062L1.31171 2.60943C1.3117 2.60942 1.31169 2.60941 1.31167 2.60939C1.21858 2.53979 1.20619 2.45349 1.23219 2.38194C1.25969 2.30628 1.33946 2.22766 1.48058 2.21912L1.48065 2.21912L3.17121 2.1164L3.31266 2.10781L3.37071 1.97853L4.00174 0.573242C4.04254 0.482616 4.14127 0.422742 4.26575 0.422742C4.39024 0.422742 4.48896 0.482616 4.52976 0.573242L5.16079 1.97853Z",
    stroke: "#FFB800",
    strokeWidth: 0.468531
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaroff);
export default __webpack_public_path__ + "static/media/star=off.f49594ed07d78ad7eaacf01810d3ba10.svg";
export { ForwardRef as ReactComponent };